import { render, staticRenderFns } from "./MyNavbar.vue?vue&type=template&id=5a780f9c&scoped=true&name=component-name"
import script from "./MyNavbar.vue?vue&type=script&lang=js"
export * from "./MyNavbar.vue?vue&type=script&lang=js"
import style0 from "./MyNavbar.vue?vue&type=style&index=0&id=5a780f9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a780f9c",
  null
  
)

export default component.exports